import { BackendErrorPayload } from '@paywithextend/components/dist/error.utils'
import axios from 'axios'
import queryString from 'query-string'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { GetUserConnectionsQueryParams } from 'src/app/PeopleContacts/redux/peopleContacts.actions'
import { PeopleMembersResponse } from 'src/models/people.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const GET_ORGANIZATION_OWNERS_AND_ADMINS_INIT =
  'app/people/peopleOwnersAndAdmins/GET_ORGANIZATION_OWNERS_AND_ADMINS_INIT'
export const GET_ORGANIZATION_OWNERS_AND_ADMINS_SUCCESS =
  'app/people/peopleOwnersAndAdmins/GET_ORGANIZATION_OWNERS_AND_ADMINS_SUCCESS'
export const GET_ORGANIZATION_OWNERS_AND_ADMINS_FAILURE =
  'app/people/peopleOwnersAndAdmins/GET_ORGANIZATION_OWNERS_AND_ADMINS_FAILURE'

export type GetOrganizationOwnersAndAdminsSuccessPayload = PeopleMembersResponse

export type GetOrganizationOwnersAndAdminsFailurePayload =
  BackendErrorPayload<string>

export interface GetOrganizationOwnersAndAdminsInitAction {
  type: typeof GET_ORGANIZATION_OWNERS_AND_ADMINS_INIT
}
export interface GetOrganizationOwnersAndAdminsSuccessAction {
  type: typeof GET_ORGANIZATION_OWNERS_AND_ADMINS_SUCCESS
  payload: GetOrganizationOwnersAndAdminsSuccessPayload
}
export interface GetOrganizationOwnersAndAdminsFailureAction {
  type: typeof GET_ORGANIZATION_OWNERS_AND_ADMINS_FAILURE
  payload: GetOrganizationOwnersAndAdminsFailurePayload
}

export type GetPeopleOwnersAndAdminsActions =
  | GetOrganizationOwnersAndAdminsInitAction
  | GetOrganizationOwnersAndAdminsSuccessAction
  | GetOrganizationOwnersAndAdminsFailureAction

export const createGetOrganizationOwnersAndAdminsInitAction =
  (): GetOrganizationOwnersAndAdminsInitAction => ({
    type: GET_ORGANIZATION_OWNERS_AND_ADMINS_INIT,
  })
const createGetOrganizationOwnersAndAdminsSuccessAction = (
  payload: GetOrganizationOwnersAndAdminsSuccessPayload,
): GetOrganizationOwnersAndAdminsSuccessAction => ({
  type: GET_ORGANIZATION_OWNERS_AND_ADMINS_SUCCESS,
  payload,
})
const createGetOrganizationOwnersAndAdminsFailureAction = (
  payload: GetOrganizationOwnersAndAdminsFailurePayload,
): GetOrganizationOwnersAndAdminsFailureAction => ({
  type: GET_ORGANIZATION_OWNERS_AND_ADMINS_FAILURE,
  payload,
})

export const getOrgOwnersAndAdmins = (
  organizationId: string,
  queryParameters?: GetUserConnectionsQueryParams,
): ThunkAction<
  Promise<
    | GetOrganizationOwnersAndAdminsFailureAction
    | GetOrganizationOwnersAndAdminsSuccessAction
  >,
  RootState,
  void,
  GetPeopleOwnersAndAdminsActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetPeopleOwnersAndAdminsActions>,
    getState: () => RootState,
  ): Promise<
    | GetOrganizationOwnersAndAdminsFailureAction
    | GetOrganizationOwnersAndAdminsSuccessAction
  > => {
    dispatch(createGetOrganizationOwnersAndAdminsInitAction())
    return axios
      .get<GetOrganizationOwnersAndAdminsSuccessPayload>(
        `/organizations/${organizationId}/members?${queryParameters ? queryString.stringify(queryParameters) : ''}&organizationRoles=ADMIN&organizationRoles=OWNER`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        async (response) => {
          return dispatch(
            createGetOrganizationOwnersAndAdminsSuccessAction(response.data),
          )
        },
        (err) => {
          return dispatch(
            createGetOrganizationOwnersAndAdminsFailureAction(
              err.response.data,
            ),
          )
        },
      )
  }
}
